export default __webpack_public_path__ + "static/media/image-drag.69229c74.svg";